import {ElementRef, Injectable} from '@angular/core';
import * as xlsx from 'xlsx';
import {BsToastService} from './bs-toast-service';

@Injectable({
  providedIn: 'root'
})

export class DataExportService {

  constructor(private bsToast: BsToastService) {
  }

  // Export from an HTML string — creates a temporary detached element, never touches the live DOM permanently
  exportHtmlToExcel(htmlString: string, excelFileName: string, sheetName: string = '') {
    try {
      const container = document.createElement('div');
      container.style.display = 'none';
      container.innerHTML = htmlString;
      document.body.appendChild(container);
      const table = container.querySelector('table') as HTMLTableElement;
      const ws: xlsx.WorkSheet = xlsx.utils.table_to_sheet(table);
      const wb: xlsx.WorkBook = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(wb, ws, sheetName || 'Sheet1');
      xlsx.writeFile(wb, excelFileName);
      this.bsToast.showSuccessToast('Exported to download directory as: ' + excelFileName, 'Success');
    } catch (ex) {
      this.bsToast.showErrorToast(ex, 'Error');
      console.error(ex);
    } finally {
      // Ensure the temporary element is always removed
      const tmp = document.body.querySelector('div[style="display: none;"]');
      if (tmp) {
        document.body.removeChild(tmp);
      }
    }
  }

  exportToExcel(pseudoDOM: ElementRef | HTMLElement | HTMLTableElement, excelFileName: string, sheetName: string = '') {
    let domToExport: HTMLElement | HTMLTableElement | null = null;

    // Backward compatibility: older callers pass ElementRef
    if ((pseudoDOM as ElementRef)?.nativeElement) {
      domToExport = (pseudoDOM as ElementRef).nativeElement as HTMLElement;
    } else {
      domToExport = pseudoDOM as HTMLElement;
    }

    try {
      const ws: xlsx.WorkSheet = xlsx.utils.table_to_sheet(domToExport);
      const wb: xlsx.WorkBook = xlsx.utils.book_new();
      if (sheetName === '') {
        xlsx.utils.book_append_sheet(wb, ws, 'Sheet1');
      } else {
        xlsx.utils.book_append_sheet(wb, ws, sheetName);
      }
      xlsx.writeFile(wb, excelFileName);
      this.bsToast.showSuccessToast('Exported to download directory as: ' + excelFileName, 'Success');
    } catch (ex) {
      this.bsToast.showErrorToast(ex, 'Error');
      console.log(ex);
    }
  }
}
